module.exports = __webpack_public_path__ + "static/media/woman_walking.e214343c.png";